import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PageTitle } from "../../../_start/layout/core";
import { PermissionsPage } from "./pages/permissions/PermissionsPage";
import { UpdatePermission } from "./pages/permissions/UpdatePermission";
import { RolesPage } from "./pages/roles/RolesPage";
import { UpdateRole } from "./pages/roles/UpdateRole";

export const RoleAndPermissionPage = () => {
  return (
    <Routes>
      {/* begin::ROLE ROUTES */}
      <Route
        path="roles"
        element={
          <>
            <PageTitle>Rollen</PageTitle>
            <RolesPage />
          </>
        }
      />
      <Route
        path="roles/:role_id/update"
        element={
          <>
            <PageTitle>Rollen</PageTitle>
            <UpdateRole />
          </>
        }
      />
      {/* end::ROLE ROUTES */}

      {/* begin::PERMISSION ROUTES */}
      <Route
        path="permissions"
        element={
          <>
            <PageTitle>Rechten</PageTitle>
            <PermissionsPage />
          </>
        }
      />
      <Route
        path="permissions/:permission_id/update"
        element={
          <>
            <PageTitle>Rechten</PageTitle>
            <UpdatePermission />
          </>
        }
      />
      {/* end::PERMISSION ROUTES */}

      <Route
        index
        element={<Navigate to="/role-and-permission/roles" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/role-and-permission/roles" replace />}
      />
    </Routes>
  );
};
